/**
 * squareItemContainer.tsx
 */
import Colors from '@shared/assets/style/default/color';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Square item container.
 */
const SquareItemContainer = styled.div<{
  focused?: boolean;
  hide?: boolean;
}>`
  align-items: center;
  justify-content: center;
  background: linear-gradient(165.05deg, #181818 46.89%, #74747450 115.78%);
  border: solid ${3 * Screen.widthRatio}px;
  border-color: ${(props) =>
    props.focused ? 'white' : Colors['border']['channel']};
  border-radius: ${20 * Screen.widthRatio}px;
  cursor: pointer;
  display: ${(props) => (props.hide ? 'none' : 'flex')};
  float: left;
  height: ${110 * Screen.widthRatio}px;
  margin-right: ${15 * Screen.widthRatio}px;
  pointer-events: all;
  text-align: center;
  width: ${110 * Screen.widthRatio}px;
  &:hover {
    border: 3px solid white;
  }
`;

export default SquareItemContainer;
